import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import {
    AiReviewPcResult,
    IAiReviewPotentialContraventionHttpController,
    IGetAiReviewPotentialContraventionProps,
} from '../IAiReviewPotentialContraventionHttpController';

export class AiReviewPotentialContraventionHttpController
    extends BaseHttpController<AiReviewPcResult>
    implements IAiReviewPotentialContraventionHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'ai-review-pc', client);
    }

    async triggerAiReview(pcId: number, props: IGetAiReviewPotentialContraventionProps): Promise<AiReviewPcResult> {
        return await this.doPost({ path: `${pcId}`, body: props }).then((res) => res.data);
    }
}
